import { render, staticRenderFns } from "./UiBracketItem.vue?vue&type=template&id=61604507&"
import script from "./UiBracketItem.vue?vue&type=script&lang=js&"
export * from "./UiBracketItem.vue?vue&type=script&lang=js&"
import style0 from "./UiBracketItem.vue?vue&type=style&index=0&id=61604507&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports